<template>
  <a
    class="vue-app-filter-count label app-sidebar-exclude label-rounded label-outline label-md"
    @click="onClick"
  >
    {{ count }} active {{ filterLabel }}
    <span
      class="clear-filters-link"
      @click.stop="onClear"
    >
      <i class="hi hi-close" />
      Clear
    </span>
  </a>
</template>

<script>
export default {
  name: 'AppFilterCount',
  props: {
    count: {
      type: Number,
    },
  },
  emits: ['click', 'clear'],
  computed: {
    filterLabel() {
      return this.count === 1 ? 'filter' : 'filters';
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
    onClear() {
      this.$emit('clear');
    },
  },
};
</script>
